export default __webpack_public_path__ + "59abb871a6ce0d7f8ab16041e3f299fa.png";